/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I count down to a future date?`)
};

const es_dd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo hacer cuenta atrás hasta una fecha futura?`)
};

const de_dd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich auf ein zukünftiges Datum herunterzählen?`)
};

const nl_dd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik aftellen tot een toekomstige datum?`)
};

const fr_dd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je compter à rebours jusqu'à une date future?`)
};

const it_dd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso fare il conto alla rovescia fino a una data futura?`)
};

const pt_br2_dd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso fazer uma contagem regressiva para uma data futura?`)
};

const pt_dd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso fazer uma contagem regressiva até uma data futura?`)
};

const ja_dd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将来の日付までカウントダウンできますか？`)
};

const zh_dd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以为未来的日期设置倒计时吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_faq4_q", locale)
	if (locale === "en") return en_dd_faq4_q(inputs)
	if (locale === "es") return es_dd_faq4_q(inputs)
	if (locale === "de") return de_dd_faq4_q(inputs)
	if (locale === "nl") return nl_dd_faq4_q(inputs)
	if (locale === "fr") return fr_dd_faq4_q(inputs)
	if (locale === "it") return it_dd_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_dd_faq4_q(inputs)
	if (locale === "pt") return pt_dd_faq4_q(inputs)
	if (locale === "ja") return ja_dd_faq4_q(inputs)
	return zh_dd_faq4_q(inputs)
};